import { FC } from "react";
import ReactTextMaskInput, { MaskedInputProps } from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

import { moneyMaskOptions, phoneNumberMask } from "lib/numbers";

const MaskedInput: FC<
  MaskedInputProps & { inputRef?: (ref?: HTMLElement) => void }
> = props => {
  const { inputRef, ...restProps } = props;

  return (
    <ReactTextMaskInput
      ref={ref => {
        inputRef && inputRef(ref ? ref.inputElement : null);
      }}
      placeholderChar={"\u2000"}
      {...restProps}
    />
  );
};

export const PhoneNumberInput: FC = props => (
  <MaskedInput {...props} mask={phoneNumberMask} />
);

const moneyInputMask = createNumberMask(moneyMaskOptions);
export const MoneyInput: FC = props => (
  <MaskedInput {...props} mask={moneyInputMask} inputMode="numeric" />
);

export const IntegerInput: FC = props => (
  <MaskedInput
    {...props}
    mask={createNumberMask({
      prefix: "",
      allowDecimal: false,
      includeThousandsSeparator: false,
    })}
  />
);

export const NumberInput: FC = props => (
  <MaskedInput
    {...props}
    mask={createNumberMask({
      prefix: "",
      allowDecimal: true,
    })}
  />
);

export const UsdIntegerInput: FC = props => (
  <MaskedInput
    {...props}
    mask={createNumberMask({
      prefix: "$",
      allowDecimal: false,
    })}
  />
);

export const TwoNumberInput: FC = props => (
  <MaskedInput
    {...props}
    mask={createNumberMask({
      prefix: "",
      integerLimit: 2,
      allowDecimal: true,
    })}
  />
);
